import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "ion-padding",
  style: {"height":"100%","overflow":"auto"}
}
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"center","padding-top":"25px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_vue3_barcode = _resolveComponent("vue3-barcode")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: _ctx.darkMode ? 'dark' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, { style: {"color":"var(--ion-color-black)"} }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t((_ctx.can_edit_access_cards || (parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests)) ? 'edit_access_card' : 'view_access_card')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  fill: "outline",
                  onClickNative: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["onClickNative"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 8, ["color"])
      ], undefined, true),
      _: 1
    }),
    _createVNode(_component_ion_content, { style: {"position":"relative","background-color":"var(--ion-color-white) !important"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "12",
                lg: "12",
                xl: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('vehicle')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        value: _ctx.vehicle_id,
                        onIonChangeNative: _cache[0] || (_cache[0] = ($event: any) => (_ctx.vehicle_id = $event.target.value)),
                        "ok-text": _ctx.t('SELECT.ok'),
                        "cancel-text": _ctx.t('SELECT.cancel')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('select_option')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicles, (vehicle) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: `vehicle_${vehicle.id}`,
                              value: vehicle.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(`${vehicle.plate_number} (${vehicle.brand} - ${vehicle.model} ${vehicle.year})`), 1)
                              ], undefined, true),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ], undefined, true),
                        _: 1
                      }, 8, ["value", "ok-text", "cancel-text"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('status')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        interface: "popover",
                        value: _ctx.status,
                        onIonChangeNative: _cache[1] || (_cache[1] = ($event: any) => (_ctx.status=$event.target.value)),
                        "ok-text": _ctx.t('SELECT.ok'),
                        "cancel-text": _ctx.t('SELECT.cancel')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('inactive')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "1" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('active')), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled", "value", "ok-text", "cancel-text"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('has_subscription')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        interface: "popover",
                        value: _ctx.has_subscription,
                        onIonChangeNative: _cache[2] || (_cache[2] = ($event: any) => (_ctx.has_subscription=$event.target.value)),
                        "ok-text": _ctx.t('SELECT.ok'),
                        "cancel-text": _ctx.t('SELECT.cancel')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('no')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "1" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('yes')), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled", "value", "ok-text", "cancel-text"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('max_vehicles_inside')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        type: "number",
                        value: _ctx.max_entrance,
                        onChangeNative: _cache[3] || (_cache[3] = ($event: any) => (_ctx.max_entrance=$event.target.value)),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.max_entrance=$event.target.value))
                      }, null, 8, ["disabled", "value"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('max_usages')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        type: "number",
                        value: _ctx.limits,
                        onChangeNative: _cache[5] || (_cache[5] = ($event: any) => (_ctx.limits=$event.target.value)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.limits=$event.target.value))
                      }, null, 8, ["disabled", "value"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('validation_date')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime_button, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        datetime: "validation_date"
                      }, null, 8, ["disabled"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('expiration_date')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime_button, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        datetime: "expiration_date"
                      }, null, 8, ["disabled"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('between_hours_start')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime_button, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        datetime: "between_hours_start"
                      }, null, 8, ["disabled"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('between_hours_end')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime_button, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        datetime: "between_hours_end"
                      }, null, 8, ["disabled"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          (_ctx.type == '3')
            ? (_openBlock(), _createBlock(_component_b_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('card_key')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                            type: "text",
                            value: _ctx.username,
                            onChangeNative: _cache[7] || (_cache[7] = ($event: any) => (_ctx.username=$event.target.value)),
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.username=$event.target.value))
                          }, null, 8, ["disabled", "value"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('zones')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        interface: "popover",
                        modelValue: _ctx.zones,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.zones) = $event)),
                        onIonChangeNative: _cache[10] || (_cache[10] = ($event: any) => (_ctx.zones=$event.target.value)),
                        multiple: "",
                        "ok-text": _ctx.t('SELECT.ok'),
                        "cancel-text": _ctx.t('SELECT.cancel')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_zones, (zone) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: zone.id + '_short',
                              data: zone,
                              value: zone.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(zone.name), 1)
                              ], undefined, true),
                              _: 2
                            }, 1032, ["data", "value"]))
                          }), 128))
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled", "modelValue", "ok-text", "cancel-text"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('tags')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        interface: "popover",
                        modelValue: _ctx.tags,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tags) = $event)),
                        onIonChangeNative: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tags=$event.target.value)),
                        multiple: "",
                        "ok-text": _ctx.t('SELECT.ok'),
                        "cancel-text": _ctx.t('SELECT.cancel')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_tags, (tag) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: tag.id + '_short',
                              data: tag,
                              value: tag.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(tag.name), 1)
                              ], undefined, true),
                              _: 2
                            }, 1032, ["data", "value"]))
                          }), 128))
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled", "modelValue", "ok-text", "cancel-text"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_2')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_monday,
                        onIonChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.allow_monday = $event.target.checked)),
                        onIonChangeNative: _cache[14] || (_cache[14] = ($event: any) => (_ctx.allow_monday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_3')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_tuesday,
                        onIonChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.allow_tuesday = $event.target.checked)),
                        onIonChangeNative: _cache[16] || (_cache[16] = ($event: any) => (_ctx.allow_tuesday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_4')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_wednesday,
                        onIonChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.allow_wednesday = $event.target.checked)),
                        onIonChangeNative: _cache[18] || (_cache[18] = ($event: any) => (_ctx.allow_wednesday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_5')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_thursday,
                        onIonChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.allow_thursday = $event.target.checked)),
                        onIonChangeNative: _cache[20] || (_cache[20] = ($event: any) => (_ctx.allow_thursday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_6')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_friday,
                        onIonChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.allow_friday = $event.target.checked)),
                        onIonChangeNative: _cache[22] || (_cache[22] = ($event: any) => (_ctx.allow_friday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_7')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_saturday,
                        onIonChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.allow_saturday = $event.target.checked)),
                        onIonChangeNative: _cache[24] || (_cache[24] = ($event: any) => (_ctx.allow_saturday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_col, {
                cols: "3",
                sm: "3",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('day_1')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_toggle, {
                        disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                        mode: "ios",
                        checked: _ctx.allow_sunday,
                        onIonChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.allow_sunday = $event.target.checked)),
                        onIonChangeNative: _cache[26] || (_cache[26] = ($event: any) => (_ctx.allow_sunday = $event.target.checked))
                      }, null, 8, ["disabled", "checked"])
                    ], undefined, true),
                    _: 1
                  }),
                  _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1))
                ], undefined, true),
                _: 1
              }),
              (_ctx.type != '1' && _ctx.type != '3')
                ? (_openBlock(), _createBlock(_component_b_col, {
                    key: 0,
                    cols: "12",
                    sm: "12",
                    md: "12",
                    lg: "12",
                    xl: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('one_time_only')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_toggle, {
                            disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                            mode: "ios",
                            checked: _ctx.one_time_only,
                            onIonChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.one_time_only = $event.target.checked)),
                            onIonChangeNative: _cache[28] || (_cache[28] = ($event: any) => (_ctx.one_time_only = $event.target.checked))
                          }, null, 8, ["disabled", "checked"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.customer_id == null || _ctx.customer_id == '') && (_ctx.user_id == null || _ctx.user_id == ''))
                ? (_openBlock(), _createBlock(_component_b_col, {
                    key: 1,
                    cols: "12",
                    sm: "12",
                    md: "12",
                    lg: "12",
                    xl: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('locale')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            disabled: !_ctx.can_edit_access_cards && !(parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests),
                            interface: "popover",
                            value: _ctx.locale,
                            onIonChangeNative: _cache[29] || (_cache[29] = ($event: any) => (_ctx.locale=$event.target.value)),
                            "ok-text": _ctx.t('SELECT.ok'),
                            "cancel-text": _ctx.t('SELECT.cancel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "fr" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('french')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "en" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('english')), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          }, 8, ["disabled", "value", "ok-text", "cancel-text"])
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.type == '0')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: 'https://qrgen.lexoh.com/?c=lexohparkingkey:' + _ctx.totp + '@' + _ctx.username,
                          width: 200,
                          style: {"width":"200px"}
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (_ctx.type == '1')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: 'https://qrgen.lexoh.com/?c=lexohparkingqr:' + _ctx.username,
                          width: 200,
                          style: {"width":"200px"}
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    (_ctx.type == '2')
                      ? (_openBlock(), _createBlock(_component_vue3_barcode, {
                          key: 2,
                          value: _ctx.username,
                          width: 1,
                          height: 50,
                          format: "CODE128"
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true)
                  ])
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          (_ctx.type != '0' && _ctx.type != '3')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-secondary btn_custom",
                type: "button",
                onClick: _cache[30] || (_cache[30] = ($event: any) => {_ctx.printCoupon();}),
                style: {"width":"100%","margin":"20px 0px 0px 0px"}
              }, _toDisplayString(_ctx.t('print')), 1))
            : _createCommentVNode("", true),
          (_ctx.can_edit_access_cards || (parseInt(_ctx.customer_id) == 0 && _ctx.can_edit_guests))
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-secondary btn_custom",
                type: "button",
                onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.updateAccessCard();}),
                style: {"width":"100%","margin":"20px 0px"}
              }, _toDisplayString(_ctx.t('save_access_card')), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_datetime, {
                showDefaultButtons: true,
                max: "2100",
                size: "cover",
                "done-text": _ctx.t('SELECT.ok'),
                "cancel-text": _ctx.t('SELECT.cancel'),
                id: "validation_date",
                locale: _ctx.$root.$i18n.locale == 'fr' ? 'fr-CA' : 'en-US',
                value: _ctx.validation_date,
                onIonChangeNative: _ctx.onValidationDateChanged
              }, null, 8, ["done-text", "cancel-text", "locale", "value", "onIonChangeNative"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_datetime, {
                showDefaultButtons: true,
                max: "2100",
                size: "cover",
                "done-text": _ctx.t('SELECT.ok'),
                "cancel-text": _ctx.t('SELECT.cancel'),
                id: "expiration_date",
                locale: _ctx.$root.$i18n.locale == 'fr' ? 'fr-CA' : 'en-US',
                value: _ctx.expiration_date,
                onIonChangeNative: _ctx.onExpirationDateChanged
              }, null, 8, ["done-text", "cancel-text", "locale", "value", "onIonChangeNative"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_datetime, {
                showDefaultButtons: true,
                size: "cover",
                "done-text": _ctx.t('SELECT.ok'),
                "cancel-text": _ctx.t('SELECT.cancel'),
                presentation: "time",
                id: "between_hours_start",
                locale: _ctx.$root.$i18n.locale == 'fr' ? 'fr-CA' : 'en-US',
                value: _ctx.between_hours_start,
                onIonChangeNative: _ctx.onHoursStartDateChanged
              }, null, 8, ["done-text", "cancel-text", "locale", "value", "onIonChangeNative"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_ion_modal, { "keep-contents-mounted": true }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_datetime, {
                showDefaultButtons: true,
                size: "cover",
                "done-text": _ctx.t('SELECT.ok'),
                "cancel-text": _ctx.t('SELECT.cancel'),
                presentation: "time",
                id: "between_hours_end",
                locale: _ctx.$root.$i18n.locale == 'fr' ? 'fr-CA' : 'en-US',
                value: _ctx.between_hours_end,
                onIonChangeNative: _ctx.onHoursEndDateChanged
              }, null, 8, ["done-text", "cancel-text", "locale", "value", "onIonChangeNative"])
            ], undefined, true),
            _: 1
          })
        ])
      ], undefined, true),
      _: 1
    })
  ], 64))
}